var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('BaseFieldGroup', _vm._b({
    staticClass: "base-select-field",
    scopedSlots: _vm._u([{
      key: "label-append",
      fn: function () {
        return [_vm._t("label-append")];
      },
      proxy: true
    }], null, true)
  }, 'BaseFieldGroup', {
    ..._setup.props,
    note: _setup.noteToUse
  }, false), [_c(_setup.BaseDropdown, {
    ref: "dropdown",
    staticClass: "w-100",
    attrs: {
      "direction": "bottom",
      "close-on-click": !_setup.isMulti
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_vm._t("activator", function () {
          return [_c('div', _vm._b({
            staticClass: "position-relative d-flex align-items-center"
          }, 'div', attrs, false), [_c('BaseInputWrapper', _vm._g(_vm._b({
            staticClass: "flex-fill",
            scopedSlots: _vm._u([_setup.slots?.selectedPrepend ? {
              key: "prepend",
              fn: function () {
                return [_vm._t("selectedPrepend", null, null, {
                  innerValue: _setup.innerValue
                })];
              },
              proxy: true
            } : null, _setup.slots?.append ? {
              key: "append",
              fn: function () {
                return [_vm._t("append")];
              },
              proxy: true
            } : null], null, true)
          }, 'BaseInputWrapper', {
            loading: _vm.loading,
            inline: _vm.inline,
            errors: _vm.errors,
            rounded: _vm.rounded
          }, false), on), [_c('div', {
            staticClass: "position-relative d-flex flex-fill"
          }, [_c('input', _vm._g({
            ref: "input",
            staticClass: "form-control border-0",
            class: [_setup.inputClasses, {
              'is-invalid alert-danger': _setup.hasErrors,
              'rounded-right-0': _setup.slots.append
            }],
            attrs: {
              "name": _vm.name,
              "readonly": "",
              "placeholder": _vm.placeholder,
              "disabled": _vm.disabled
            },
            domProps: {
              "value": _setup.fieldLabel
            }
          }, on)), !_vm.errors.length ? _c('BaseIcon', {
            staticClass: "align-self-center mr-3 position-absolute right-0",
            staticStyle: {
              "pointer-events": "none"
            },
            attrs: {
              "icon": "$down"
            }
          }) : _vm._e()], 1)])], 1)];
        }, null, {
          loading: _vm.loading,
          inline: _vm.inline,
          errors: _vm.errors,
          rounded: _vm.rounded,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled,
          fieldLabel: _setup.fieldLabel,
          hasErrors: _setup.hasErrors,
          size: _vm.size,
          attrs,
          on
        })];
      }
    }, {
      key: "default",
      fn: function ({
        opened
      }) {
        return [_c(_setup.BaseListGroup, {
          ref: "list",
          staticClass: "overflow-auto",
          staticStyle: {
            "max-height": "200px"
          }
        }, [_vm.emptyValue !== undefined && !_setup.isMulti ? _c('BaseListItem', _vm._g({
          directives: [{
            name: "auto-focus",
            rawName: "v-auto-focus",
            value: _setup.isSelected(_vm.emptyValue),
            expression: "isSelected(emptyValue)"
          }],
          staticClass: "no-ripple",
          class: {
            'focused': _setup.focusedItemId === 'emptyOption'
          },
          attrs: {
            "density": "comfortable",
            "data-item-id": "emptyOption"
          }
        }, _setup.getItemEvents(_vm.emptyValue)), [_c('div', [_vm._v(_vm._s(_vm.emptyLabel))])]) : _vm._e(), _vm._l(_setup.groupedOptions, function (group) {
          return [group.key != _setup.DEFAULT_GROUP_KEY ? _c('BaseListGroupHeading', {
            key: group.key + '_header',
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(group.key) + " ")]) : _vm._e(), _vm._l(group.items, function (item, i) {
            return _c('BaseListItem', _vm._g({
              directives: [{
                name: "auto-focus",
                rawName: "v-auto-focus",
                value: _setup.isSelected(item.value) || (!_vm.emptyValue || _setup.isMulti) && i === 0,
                expression: "isSelected(item.value) || ((!emptyValue || isMulti) && i === 0)"
              }],
              key: item.id,
              staticClass: "no-ripple",
              class: {
                'focused': _setup.focusedItemId === item.id
              },
              attrs: {
                "tabindex": !opened ? -1 : undefined,
                "data-item-id": item.id,
                "density": "comfortable"
              },
              scopedSlots: _vm._u([{
                key: "append",
                fn: function () {
                  return undefined;
                },
                proxy: true
              }, {
                key: "prepend",
                fn: function () {
                  return [[_vm._t("listItemPrepend", null, null, {
                    item
                  })], item.icon || _setup.isMulti ? _c('div', {
                    class: {
                      'text-primary': _setup.isMulti && _setup.isSelected(item.value),
                      'text-black-50': _setup.isMulti && !_setup.isSelected(item.value)
                    },
                    staticStyle: {
                      "width": "25px"
                    }
                  }, [_c('BaseIcon', {
                    attrs: {
                      "icon": _setup.isMulti ? _setup.isSelected(item.value) ? _setup.icons.checkbox : _setup.icons.unchecked : item.icon ?? ''
                    }
                  })], 1) : _vm._e()];
                },
                proxy: true
              }], null, true)
            }, _setup.getItemEvents(item.value)), [_c('div', [_c('DisplayText', {
              attrs: {
                "text": item.text
              }
            })], 1), item.description ? _c('div', {
              staticClass: "option-note small text-muted"
            }, [_c('DisplayText', {
              attrs: {
                "text": item.description
              }
            })], 1) : _vm._e()]);
          })];
        })], 2)];
      }
    }], null, true)
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };